export const fa: Record<string, string> = {
  // ---------- Tabs ----------
  "tabs.dashboard": "داشبورد",
  "tabs.charts": "نمودارها",
  "tabs.records": "ثبت‌ها",
  "tabs.shifts": "شیفت‌ها",
  "tabs.people": "افراد",
  "tabs.settings": "تنظیمات",
  "tabs.report": "گزارش",
  "tabs.emergency": "اضطراری",
  "tabs.my_records": "ثبت‌های من",
  "tabs.turbines": "توربین‌ها",
  "tabs.automatika": "اتوماسیون",

  // ---------- Автоматика (SCADA) ----------
  "auto.sub_overview": "نمای کلی",
  "auto.sub_charts": "نمودارها",
  "auto.sub_anomalies": "انحرافات",
  "auto.sub_data": "داده‌ها",
  "auto.all": "همه",
  "auto.last_3d": "۳ روز اخیر",
  "auto.last_1d": "روز آخر",
  "auto.data_range": "داده‌ها",
  "auto.timeframe": "بازه زمانی",
  "auto.tf_all": "همه داده‌ها",
  "auto.tf_7d": "۷ روز اخیر",
  "auto.tf_3d": "۳ روز اخیر",
  "auto.tf_1d": "۲۴ ساعت اخیر",
  "auto.tf_12h": "۱۲ ساعت اخیر",
  "auto.tf_6h": "۶ ساعت اخیر",
  "auto.tf_1h": "یک ساعت اخیر",
  "auto.tf_custom": "بازه دلخواه…",
  "auto.hide_zeros": "پنهان‌کردن صفرها",
  "auto.truncated": "۵۰۰ مورد برتر",
  "auto.tap_for_details": "برای جزئیات کامل بزنید",
  "auto.snapshot_title": "📸 وضعیت در این لحظه",
  "auto.resolution": "تفکیک‌پذیری",
  "auto.res_auto": "خودکار",
  "auto.res_raw": "ثانیه‌ای",
  "auto.reset_zoom": "بازنشانی زوم",
  "auto.deviations_n": "{n} علامت‌خورده",
  "auto.drill_hint": "برای بزرگ‌نمایی روی هر نقطه بزنید؛ یا نوار پایین را بکشید و «زوم به محدوده» را بزنید. نقاط قرمز در آن بازه انحراف داشتند.",
  "auto.zoom_to_sel": "زوم به محدوده",
  "auto.back": "← بازگشت",
  "auto.filter_metric": "فیلتر بر اساس شاخص",
  "auto.all_metrics": "همه شاخص‌ها",
  "auto.minutes": "دقیقه",
  "auto.min_short": "دق",
  "auto.bucket": "بازه",
  "auto.kpi_running": "در حال کار",
  "auto.kpi_peak_power": "اوج توان",
  "auto.kpi_avg": "میانگین",
  "auto.kpi_span": "دوره",
  "auto.kpi_energy": "انرژی تولیدی",
  "auto.kwh": "کیلووات‌ساعت",
  "auto.mwh": "مگاوات‌ساعت",
  "auto.col_metric": "شاخص",
  "auto.no_anomalies": "انحراف قابل‌توجهی در این دوره نیست.",
  "auto.anomalies_hint": "{n} رویداد (≥ {floor}٪ از نرمال، فراتر از ±۲σ در دوره‌های کارکرد).",
  "auto.off_normal": "از نرمال",
  "auto.normal": "نرمال",
  "auto.when": "زمان",
  "auto.upload_title": "بارگذاری CSV ایستگاه",
  "auto.upload_hint": "خروجی SCADA (جداشده با فاصله، ‎.csv یا ‎.gz). فایل بزرگ را ‎.gz بفرستید. در پس‌زمینه پردازش می‌شود؛ جدا از ثبت‌های دستی.",
  "auto.uploading": "در حال بارگذاری…",
  "auto.upload_started": "فایل دریافت شد — پردازش در پس‌زمینه…",
  "auto.upload_done": "انجام شد — {rows} ردیف وارد شد.",
  "auto.upload_error": "خطای پردازش — قالب فایل را بررسی کنید.",
  "auto.export_xlsx": "📥 دانلود اکسل (دوره)",
  "auto.export_hint": "ردیف‌های خام ثانیه‌ای برای دوره انتخابی، ستون‌های اصلی، هر روز یک برگه.",
  "auto.imports_title": "بارگذاری‌ها",
  "auto.col_file": "فایل",
  "auto.col_status": "وضعیت",
  "auto.col_rows": "ردیف",
  "auto.col_period": "دوره",

  // ---------- Turbines ----------
  "turbines.title": "🏭 توربین‌ها",
  "turbines.empty_for_station": "ایستگاه شما هنوز توربین ندارد. به مدیر مراجعه کنید.",
  "turbines.none_for_station": "توربینی نیست.",
  "turbines.active": "فعال",
  "turbines.inactive": "غیرفعال",
  "turbines.status_running": "در حال کار",
  "turbines.status_stopped": "متوقف",
  "turbines.status_off": "خاموش",
  "turbines.activate": "فعال‌سازی",
  "turbines.deactivate": "غیرفعال‌سازی",
  "turbines.state_running": "در حال کار",
  "turbines.state_stopped": "متوقف",
  "turbines.state_off": "خارج از سرویس",
  "turbines.start_btn": "شروع",
  "turbines.start_sub": "ثبت شروع با KV فعلی",
  "turbines.start_title": "شروع {name}",
  "turbines.confirm_start": "شروع",
  "turbines.stop_btn": "توقف",
  "turbines.stop_sub": "ثبت توقف با KW، زمان و علت",
  "turbines.stop_title": "توقف {name}",
  "turbines.confirm_stop": "توقف",
  "turbines.stop_time": "زمان توقف",
  "turbines.stop_reason": "علت",
  "turbines.stop_reason_placeholder": "چرا توربین متوقف شد؟",
  "turbines.recent_events": "تاریخچه رویدادها",
  "turbines.evt_start": "شروع",
  "turbines.evt_stop": "توقف",
  "turbines.tab_list": "توربین‌ها",
  "turbines.tab_history": "تاریخچه",
  "turbines.no_events": "هنوز رویدادی نیست.",
  "turbines.fill_btn": "تکمیل گزارش",
  "turbines.fill_sub": "ثبت مقادیر برای این توربین",
  "turbines.fill_sub_offline": "توربین متوقف است — ورودی نارنجی می‌شود",

  // ---------- Common ----------
  "common.loading": "در حال بارگذاری…",
  "common.cancel": "لغو",
  "common.save": "ذخیره",
  "common.delete": "حذف",
  "common.edit": "ویرایش",
  "common.create": "ایجاد",
  "common.close": "بستن",
  "common.retry": "تلاش مجدد",
  "common.back": "بازگشت",
  "common.add": "افزودن",
  "common.submit": "ارسال",
  "common.no_changes": "تغییری نیست",
  "common.saved": "ذخیره شد",
  "common.copied": "کپی شد",
  "common.copy_link": "📋 کپی لینک",
  "common.no_data": "برای بازه انتخاب‌شده داده‌ای وجود ندارد.",
  "common.empty": "هنوز چیزی نیست.",
  "common.error_generic": "خطایی رخ داد. دوباره تلاش کنید.",
  "common.no_connection": "اتصال به سرور برقرار نیست",
  "common.timeout": "سرور پاسخ نمی‌دهد — دوباره تلاش کنید",

  // ---------- Access / desktop hint ----------
  "access.locked_title": "دسترسی ندارید",
  "access.locked_hint": "تنها کاربران ثبت‌شده می‌توانند این اپ را باز کنند. از مدیر لینک دعوت بخواهید.",
  "desktop_hint.title": "در تلگرام باز کنید",
  "desktop_hint.body": "این یک Mini App تلگرام است. بات را در تلگرام باز کنید و 📱 کنار فیلد ورودی را بزنید.",

  // ---------- Periods ----------
  "period.today": "امروز",
  "period.yest": "دیروز",
  "period.7d": "۷ روز",
  "period.30d": "۳۰ روز",
  "period.all": "همه",

  // ---------- Status / types ----------
  "status.completed": "✅",
  "status.miss_short": "از دست",
  "type.plan": "برنامه",
  "type.emergency": "🚨 اضطراری",
  "type.missed": "🚫 از دست رفته",
  "type.late": "🟨 با تأخیر",
  "type.offline": "🟠 آفلاین",
  "filter.all": "همه",

  // ---------- Charts ----------
  "charts.title": "📈 نمودارها",
  "charts.select_chart": "انتخاب نمودار",
  "charts.turbine": "توربین",
  "charts.period": "بازه",
  "charts.kw_kv_label": "نوسانات KW و KV",
  "charts.kw_kv_title": "KW و KV در طول زمان",
  "charts.kw_kv_hint": "دو خط: KW (محور چپ) و KV (محور راست). جهش‌های ولتاژ به‌راحتی دیده می‌شوند.",
  "charts.kw_kv_offline_title": "روند KW و KV (توربین متوقف)",
  "charts.kw_kv_offline_hint": "فقط ثبت‌هایی که هنگام توقف توربین انجام شده‌اند. KW (نارنجی، محور چپ) و KV (بنفش، محور راست).",

  "charts.compare_label": "مقایسه توربین‌ها (KW)",
  "charts.compare_hint": "منحنی توان همه توربین‌ها در یک نمودار. توزیع نامتعادل بار و توربین‌های متوقف به‌راحتی دیده می‌شود.",

  "charts.timeline_label": "خط زمانی کار/توقف",
  "charts.timeline_hint": "نوارهای افقی برای هر توربین: سبز = در حال کار، قرمز = متوقف. کل زمان توقف در بازه روی یک صفحه.",
  "charts.timeline_running": "در حال کار",
  "charts.timeline_stopped": "متوقف",

  "charts.temperatures_label": "دماهای BT",
  "charts.temperatures_hint": "سنسورهای دما BT 371, BT 372, BT 331, BT 332 در یک نمودار. جهش هر منحنی نشانه ریسک گرم‌شدگی است.",

  "charts.frequency_label": "فرکانس (Hz)",
  "charts.frequency_hint": "فرکانس تولید با خطوط مرجع 49.5 و 50.5. انحراف بیش از 0.5 Hz یعنی مشکل در شبکه.",
  "charts.freq_low": "49.5 Hz (پایین)",
  "charts.freq_high": "50.5 Hz (بالا)",

  "charts.stop_reasons_label": "علل توقف",
  "charts.stop_reasons_hint": "توزیع دلایل از فرم Stop توربین. نشان می‌دهد چه مشکلاتی بیشتر تکرار می‌شوند.",
  "charts.stop_reasons_empty": "در این بازه هیچ توقفی ثبت نشده.",
  "charts.reason_unknown": "نامشخص",

  "charts.kw_histogram_label": "توزیع KW (هیستوگرام)",
  "charts.kw_histogram_hint": "چند ثبت در هر بازه ۲۰۰ KW قرار گرفته. حالت کاری غالب توربین را نشان می‌دهد.",

  "charts.cos_kvar_label": "cos φ و Kvar",
  "charts.cos_kvar_hint": "ضریب توان cos φ (محور چپ، 0..1) و توان راکتیو Kvar (محور راست). افت cos φ یعنی مشکل کیفیت تولید.",

  "charts.pressure_label": "فشارها (BP 371، Bar، Pipe pressure)",
  "charts.pressure_hint": "همه فشارها در یک نمودار. جهش‌های شدید نشانه شرایط اضطراری در مدار هیدرولیک یا بخار است.",

  "charts.scatter_label": "KW vs KV (پراکندگی)",
  "charts.scatter_hint": "نمودار پراکندگی، هر نقطه = یک ثبت. همبستگی توان و ولتاژ را نشان می‌دهد؛ نقاط پرت برجسته‌اند.",

  "analysis.title": "تحلیل",
  "analysis.no_data": "داده کافی برای تحلیل در این بازه وجود ندارد.",
  "analysis.records": "تعداد ثبت‌ها: {n}.",

  "analysis.kv_ok": "ولتاژ در محدوده نرمال (KV {min}–{max}، هدف ۱۷–۲۲).",
  "analysis.kv_out": "ولتاژ خارج از محدوده نرمال (KV {min}–{max}، انتظار ۱۷–۲۲). وضعیت شبکه را بررسی کنید.",
  "analysis.kw_stable": "توان خروجی پایدار است، میانگین {avg} KW.",
  "analysis.kw_unstable": "توان ناپایدار: پراکندگی {cv}% از میانگین {avg} KW. بار را بررسی کنید.",

  "analysis.turbine_idle": "{name}: در این بازه داده‌ای ثبت نشده — توربین متوقف بود.",
  "analysis.turbine_avg": "{name}: میانگین توان {avg} KW.",
  "analysis.compare_balanced": "بار به‌طور یکنواخت بین توربین‌ها توزیع شده.",
  "analysis.compare_imbalance": "عدم تعادل بار: {hi} ({hiAvg} KW) به‌مراتب بیشتر از {lo} ({loAvg} KW).",

  "analysis.timeline_overall": "زمان کار جمعی همه توربین‌ها: {uptime}%. کل توقف‌ها: {stops}.",
  "analysis.timeline_turbine": "{name}: {uptime}% زمان در حال کار، توقف {downtime}.",

  "analysis.temp_ok": "دماها نرمال، حداکثر {max}°C (آستانه ۷۰°C).",
  "analysis.temp_warn": "دما بالا، حداکثر {max}°C. نرمال تا ۷۰°C، بحرانی بالای ۸۵°C — سنسورها را پایش کنید.",
  "analysis.temp_critical": "گرم‌شدگی! حداکثر {max}°C در سنسورها: {sensors}. نیاز به توجه دارد.",
  "analysis.temp_avg": "میانگین دما: {avg}°C.",

  "analysis.freq_ok": "فرکانس پایدار: {min}–{max} Hz، در محدوده نرمال ۴۹٫۵–۵۰٫۵.",
  "analysis.freq_bad": "فرکانس از محدوده خارج شده: زیر ۴۹٫۵ — {low} نقطه، بالای ۵۰٫۵ — {high} (از {total}).",
  "analysis.freq_avg": "میانگین فرکانس: {avg} Hz.",

  "analysis.stop_none": "در این بازه هیچ توقفی نبوده — عالی.",
  "analysis.stop_total": "کل توقف‌ها: {n}.",
  "analysis.stop_top": "شایع‌ترین علت: «{name}» ({pct}%).",
  "analysis.stop_dominant": "یک علت غالب است: «{name}» ({pct}% همه توقف‌ها). بررسی منبع توصیه می‌شود.",
  "analysis.stop_variety": "تنوع علل: {n} دسته متفاوت.",

  "analysis.hist_top": "بیشترین فراوانی توان در بازه {range} KW ({pct}%).",
  "analysis.hist_low": "{pct}% ثبت‌ها با توان پایین — کم‌باری مکرر.",
  "analysis.hist_normal": "{pct}% زمان در بار نرمال.",
  "analysis.hist_avg": "میانگین توان: {avg} KW.",

  "analysis.cos_ok": "cos φ نرمال (میانگین {avg}). کیفیت تولید بالا.",
  "analysis.cos_warn": "cos φ کاهش یافته (میانگین {avg}). نرمال ≥۰٫۹۵، جبران توان راکتیو توصیه می‌شود.",
  "analysis.cos_bad": "cos φ پایین (میانگین {avg}). تلفات قابل‌توجه — کم‌باری یا بار راکتیو بزرگ.",
  "analysis.kvar_avg": "Kvar: میانگین {avg}، بازه {min}–{max}.",

  "analysis.pressure_field": "{name}: میانگین {avg}، بازه {min}–{max}.",

  "analysis.scatter_few": "نقاط برای تحلیل همبستگی کم است.",
  "analysis.scatter_points": "{n} نقطه روی نمودار.",
  "analysis.scatter_corr_pos": "همبستگی مثبت قوی بین KW و KV (r={r}). ولتاژ با افزایش توان بالا می‌رود.",
  "analysis.scatter_corr_neg": "همبستگی منفی قوی بین KW و KV (r={r}). ولتاژ با افزایش توان پایین می‌آید.",
  "analysis.scatter_corr_none": "همبستگی مشخصی بین KW و KV نیست (r={r}).",

  // ---------- Dashboard ----------
  "dashboard.title": "📊 داشبورد",
  "dashboard.kpi.completed": "تکمیل‌شده",
  "dashboard.kpi.completed_sub": "{pct}٪ از برنامه",
  "dashboard.kpi.total": "کل اسلات‌ها",
  "dashboard.kpi.missed": "🚫 از دست رفته",
  "dashboard.kpi.late": "🟨 با تأخیر",
  "dashboard.kpi.emergency": "🚨 اضطراری",
  "dashboard.kpi.avg_response": "میانگین پاسخ",
  "dashboard.kpi.avg_response_sub": "از اعلان تا شروع",
  "dashboard.kpi.avg_kw": "میانگین KW",
  "dashboard.kpi.avg_kv": "میانگین KV",
  "dashboard.kpi.min_max_sub": "حداقل / حداکثر در بازه",
  "dashboard.kpi.min": "حداقل",
  "dashboard.kpi.max": "حداکثر",
  "dashboard.turbines.downtime": "زمان توقف",
  "dashboard.turbines.last_reading": "آخرین ثبت",
  "dashboard.turbines.no_downtime": "بدون توقف",
  "dashboard.turbines.no_data": "بدون داده",
  "dashboard.turbines.just_now": "همین الان",
  "dashboard.turbines.ago": "پیش",
  "dashboard.turbines.unit_d": "روز",
  "dashboard.turbines.unit_h": "س",
  "dashboard.turbines.unit_min": "د",
  "dashboard.sparkline.title": "روند KW در ۲۴ ساعت",
  "dashboard.sparkline.hint": "تمام ثبت‌های آنلاین توان از هر دو توربین",
  "dashboard.distribution.title": "توزیع اسلات‌ها",
  "dashboard.distribution.on_time": "✅ به‌موقع",
  "dashboard.distribution.late": "🟨 با تأخیر",
  "dashboard.distribution.missed": "🚫 از دست رفته",
  "dashboard.distribution.pending": "⏳ در حال انجام",
  "dashboard.distribution.emergency": "🚨 اضطراری",
  "dashboard.by_day.title": "تکمیل بر اساس روز، ٪",
  "dashboard.by_day.tooltip": "{pct}٪ ({completed}/{total})",
  "dashboard.by_day.tooltip_label": "تکمیل",
  "dashboard.by_hour.title": "تکمیل بر اساس ساعت",
  "dashboard.by_hour.legend": "🟢 بالا · 🟡 متوسط · 🔴 پایین",
  "dashboard.by_hour.legend_count": "تعداد گزارش‌های ثبت‌شده در هر ساعت روز (در بازه انتخاب‌شده).",
  "dashboard.by_hour.no_data": "داده‌ای نیست",
  "dashboard.users.title": "رتبه‌بندی اپراتورها",
  "dashboard.users.col_name": "نام",
  "dashboard.users.col_avg": "میانگین پاسخ",
  "dashboard.users.bar_title": "میانگین زمان پاسخ، ثانیه",
  "dashboard.empty": "برای بازه انتخاب‌شده داده‌ای نیست. بازه دیگری انتخاب کنید یا منتظر تیک ساعت بعدی بمانید.",

  // ---------- Records (admin) ----------
  "records.title": "📋 ثبت‌ها",
  "records.from": "از",
  "records.to": "تا",
  "records.download_xlsx": "📥 دانلود اکسل",
  "records.xlsx_per_day": "هر روزِ بازه یک برگه جداگانه می‌شود (مطابق ودومست شاخص‌ها).",
  "records.custom_preview": "🛠 پیش‌نمایش سفارشی",
  "records.col_date": "تاریخ",
  "records.col_turbine": "توربین",

  "custom_preview.title": "🛠 پیش‌نمایش سفارشی",
  "custom_preview.period": "بازه",
  "custom_preview.turbine": "توربین",
  "custom_preview.type": "نوع ثبت",
  "custom_preview.fields": "انتخاب‌شده: {n} از {total}",
  "custom_preview.select_all": "همه را انتخاب کن",
  "custom_preview.clear": "پاک کردن",
  "custom_preview.build_btn": "ساخت جدول",
  "custom_preview.building": "در حال ساخت…",
  "custom_preview.rows_count": "مجموع ردیف‌ها: {n}",
  "custom_preview.sort_hint": "برای مرتب‌سازی کلیک کنید",
  "records.col_slot": "اسلات",
  "records.col_who": "کاربر",
  "records.col_type": "نوع",
  "records.col_status": "وضعیت",
  "records.detail.title": "ثبت #{id}",
  "records.detail.slot": "اسلات",
  "records.detail.responsible": "مسئول",
  "records.detail.started": "شروع",
  "records.detail.completed": "پایان",
  "records.detail.response": "پاسخ",
  "records.detail.fill": "زمان تکمیل",
  "records.detail.reason": "علت",
  "records.detail.seconds": "ث",

  // ---------- My records (responsible) ----------
  "my_records.title": "📋 ثبت‌های من",
  "my_records.download_xlsx": "📥 دانلود اکسل",

  // ---------- Shifts (admin) ----------
  "shifts.title": "📅 شیفت‌ها",
  "shifts.choose_user": "یک مسئول انتخاب کنید",
  "shifts.fill_range": "📐 پر کردن بازه",
  "shifts.active_count": "شیفت‌های فعال ({n})",
  "shifts.empty": "شیفتی وجود ندارد. در تقویم روی روزی بزنید.",
  "shifts.range.title": "📐 پر کردن بازه",
  "shifts.range.from": "شروع",
  "shifts.range.to": "پایان",
  "shifts.range.invalid": "تاریخ پایان قبل از تاریخ شروع است",
  "shifts.range.added": "افزوده: {added}، رد شده: {skipped}",
  "shifts.deactivated": "غیرفعال",
  "shifts.more_hidden": "…و {n} شیفت دیگر (پنهان)",

  // ---------- People & stations ----------
  "people.title": "👥 افراد و ایستگاه‌ها",
  "people.stations": "🏭 ایستگاه‌ها ({n})",
  "people.add_station": "➕ افزودن ایستگاه",
  "people.station.name": "نام",
  "people.station.city": "شهر",
  "people.station.tz": "منطقه زمانی (Europe/Kyiv)",
  "people.station.new_title": "ایستگاه جدید",
  "people.station.name_placeholder": "نام (مثلاً Energo-2)",
  "people.station.confirm_delete": "ایستگاه «{name}» حذف شود؟",
  "people.station.fill_required": "نام و شهر را پر کنید",
  "people.invite.title": "دعوت جدید",
  "people.invite.placeholder": "نام کامل اپراتور",
  "people.invite.create": "➕ ایجاد دعوت",
  "people.invite.created_for": "✅ دعوت برای «{name}»",
  "people.invite.copy_failed": "کپی نشد. لینک را دستی انتخاب کنید.",
  "people.list_title": "اپراتورهای مسئول ({n})",
  "people.list_empty": "هنوز کسی نیست. یک دعوت ایجاد کنید.",
  "people.deactivate": "غیرفعال‌سازی",
  "people.activate": "فعال‌سازی",
  "people.station_label": "ایستگاه:",
  "people.station_none": "— بدون ایستگاه —",

  // ---------- Settings ----------
  "settings.title": "⚙ تنظیمات",
  "settings.notification_interval": "فاصله اعلان‌ها، دقیقه ({min}–{max})",
  "settings.notification_hint": "هر {n} دقیقه اپراتورها یک اعلان تلگرام دریافت می‌کنند. از تیک بعدی اعمال می‌شود.",
  "settings.range_error": "مقدار مجاز: {min}–{max}",
  "settings.language": "زبان",
  "settings.trigger_running": "در حال اجرا…",
  "settings.trigger_label": "⚡ تریگر: اجرای تیک ساعت",
  "settings.trigger_success": "✅ تیک اجرا شد. اپراتورهای در شیفت اعلان دریافت می‌کنند.",
  "settings.trigger_failed": "⚠ {error}",

  // ---------- Report (responsible landing) ----------
  "report.title": "📝 گزارش",
  "report.ready_to_fill": "آماده ثبت است. دکمه زیر را بزنید.",
  "report.no_slot": "⏳ ارسال ممکن نیست",
  "report.no_slot_hint": "توربین متوقف است یا شما در حال تعطیلی هستید.",
  "report.day_off": "🌴 امروز روز تعطیل شماست",
  "report.day_off_hint": "اعلان‌ها تا پایان شیفت متوقف است.",
  "report.fill_btn": "تکمیل گزارش",
  "report.fill_btn_offline": "تکمیل (توربین متوقف)",
  "report.fill_sub_active": "مقادیر برنامه برای ساعت جاری",
  "report.fill_sub_disabled": "در حال حاضر در دسترس نیست",
  "report.fill_sub_day_off": "غیرقابل‌دسترس — تعطیل",
  "report.fill_sub_offline": "ورودی به‌رنگ نارنجی علامت‌گذاری می‌شود",
  "report.emergency_btn": "وضعیت اضطراری",
  "report.emergency_sub": "ثبت اضطراری: KW + KV",
  "report.day_off_btn_off": "تعطیل",
  "report.day_off_btn_on": "لغو تعطیل",
  "report.day_off_sub_off": "علامت‌گذاری امروز به‌عنوان روز غیرکاری",
  "report.day_off_sub_on": "ازسرگیری اعلان‌های شیفت",
  "report.day_off_confirm_on": "امروز را تعطیل کنیم؟ دیگر اعلانی برای این شیفت دریافت نمی‌کنید.",
  "report.day_off_confirm_off": "لغو علامت «تعطیل» — اعلان‌ها از سر گرفته شوند؟",

  // ---------- Report form ----------
  "report_form.title": "📋 گزارش برنامه‌ای",
  "report_form.slot_label": "اسلات",
  "report_form.placeholder_pair": "X یا X/Y",
  "report_form.placeholder_single": "—",
  "report_form.filled_count": "{n} از {total} پر شده. ارسال جزئی هم مجاز است.",
  "report_form.expand_all": "باز کردن همه",
  "report_form.collapse_all": "بستن همه",
  "bool.on": "روشن",
  "bool.off": "خاموش",
  "report_form.submit": "ارسال",
  "report_form.submit_sub": "ذخیره مقادیر واردشده",
  "report_form.submitting": "در حال ارسال…",
  "report_form.cancel": "لغو",
  "report_form.cancel_sub": "مقادیر ذخیره نمی‌شوند",
  "report_form.already_completed": "این اسلات قبلاً تکمیل شده است.",
  "report_form.no_slot": "اسلات بازی نیست.",
  "report_form.offline_title": "توربین متوقف است",
  "report_form.offline_hint": "ورودی ذخیره می‌شود اما به‌رنگ نارنجی علامت‌گذاری می‌شود تا مشخص باشد در حالت توقف توربین ثبت شده است.",

  // ---------- Emergency form ----------
  "emergency.title": "🚨 وضعیت اضطراری",
  "emergency.intro": "ثبت اضطراری. KW و علت الزامی‌اند؛ سایر شاخص‌ها اختیاری هستند. پس از ارسال مدیران مطلع می‌شوند.",
  "emergency.reason_label": "علت",
  "emergency.reason_placeholder": "شرح دهید چه اتفاقی افتاد",
  "emergency.reason_required": "فیلد الزامی",
  "emergency.submit_sub_ok": "ذخیره و اطلاع مدیران",
  "emergency.submit_sub_disabled": "ابتدا علت را وارد کنید",
  "emergency.show_extras": "تکمیل سایر فیلدها (اختیاری)",
  "emergency.hide_extras": "پنهان کردن سایر فیلدها",
  "emergency.landing_what": "«وضعیت اضطراری» چیست؟",
  "emergency.landing_when": "این فقط برای رویدادهای واقعاً غیرعادی است — خرابی، نوسان، نشتی و غیره.",
  "emergency.landing_warn": "اگر فقط می‌خواهید مقادیر معمول را ثبت کنید — این برگه را ببندید و از «📝 گزارش» استفاده کنید.",
  "emergency.landing_btn": "ایجاد ثبت اضطراری",
};
